import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Button, Input } from "semantic-ui-react";
import TransmissionList from "./TransmissionList";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { Link } from "react-router-dom";

const TransmissionDashboard: React.FC = () => {
  const transmissionStore = useContext(TransmissionStore);
  const { loadTransmissions, searchTransmission } = transmissionStore;
  const [term, setTerm] = useState("");

  const handleInputChange=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchTransmission(event.currentTarget.value);
  }

  useEffect(() => {
    loadTransmissions();
  }, []);

  if (transmissionStore.loadingInitial)
    return <LoadingComponent content="Loading 5G Transmissions" />;

  return (
    <Segment>
      <Grid>
        <Grid.Column width={4}>
         <Input  type="text" icon="search" placeholder="Search projects" onChange={handleInputChange} value={term}/>
        </Grid.Column>
        <Grid.Column width={4}>
  
        </Grid.Column>
        <Grid.Column width={5}></Grid.Column>
      <Grid.Column textAlign="center" width={3}>
        <Button
          as={Link}
          to={`/projectmanagement/transmission-create`}
          color="linkedin"
          icon="add"
          content="Create New"
        />
      </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <TransmissionList />
        </Grid.Column>
        
      </Grid>
    </Segment>
  );
};

export default observer(TransmissionDashboard);
